<template>
  <div>
    <div class="inst-title">정상 모델 크기 검사</div>
    <pre class="inst-desc">
모델의 크기가 비정상적으로 작거나 클 때 나타납니다.
<div class="text-sm">ex: 부피가 10cm^3 보다 작거나 / 한 방향의 길이가 1km 이상으로 큰 경우</div></pre>
    <div class="inst-subtitle">[정상 모델 크기 검사가 실패하는 경우]</div>
    <pre
      class="inst-desc"
    >· 비다양체 모델 (모델의 면들이 뒤집혀져 있거나 서로 연결이 되어 있지 않는 등) 인 경우<br>· 자세한 설명과 문제해결 방법은 생산을 위한 3D모델링 조건 을 참고해 주세요.</pre>
    <div class="inst-subtitle">[정상모델 임에도 해당 검사에 실패했을 경우]</div>
    <pre
      class="inst-desc"
    >· 3D 프로그램 상 단위가 정상적으로 세팅 되어있는지 확인<br>· 다른 프로그램에서도 동일한 크기로 불러와지는지 확인<br><div class="text-sm">*산업에서는 주로 mm 단위를 사용하고 한양3D팩토리 실시간 견적 페이지에서는 mm 단위를 지원합니다.</div></pre>
  </div>
</template>

<script setup></script>
